import { useCopyToClipboard } from "../../hooks";
import { View } from "./View";

export interface ICopyButtonProps {
  name?: string;
  className?: string;
  iconDescription?: string;
  feedbackInfo?: string;
  stringToCopy: string;
  copyIcon?: string;
}
export const CopyButton = (props: ICopyButtonProps) => {
  const { copyToClipboard, displayAlertText, alertTextDisplayed } =
    useCopyToClipboard(props.stringToCopy, props.feedbackInfo || "");

  // hide copy button if string is empty
  const isEmptyString =
    props.stringToCopy === null || props.stringToCopy === "";

  return isEmptyString ? null : (
    <View
      {...props}
      isPopoverOpen={displayAlertText}
      handleCopy={copyToClipboard}
    />
  );
};
